import React from 'react';

interface TaskItem {
  id: string;
  title: string;
  priority: 'high' | 'medium' | 'low';
  dueDate: string;
  completed: boolean;
  assignee?: string;
}

interface TaskWidgetProps {
  title?: string;
  tasks?: TaskItem[];
  onTaskToggle?: (taskId: string) => void;
}

const TaskWidget: React.FC<TaskWidgetProps> = ({ 
  title = "Pending Tasks",
  tasks,
  onTaskToggle
}) => {
  const defaultTasks: TaskItem[] = [
    { id: '1', title: 'Review compliance audit', priority: 'high', dueDate: 'Today', completed: false, assignee: 'John D.' },
    { id: '2', title: 'Update security policies', priority: 'medium', dueDate: 'Tomorrow', completed: false, assignee: 'Jane S.' },
    { id: '3', title: 'Quarterly risk assessment', priority: 'high', dueDate: '3 days', completed: false, assignee: 'Mike R.' },
    { id: '4', title: 'Training documentation', priority: 'low', dueDate: '1 week', completed: true, assignee: 'Sarah L.' },
    { id: '5', title: 'Vendor evaluation report', priority: 'medium', dueDate: '2 days', completed: false, assignee: 'Tom W.' }
  ];

  const tasksData = tasks || defaultTasks;

  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'high': return '#dc2626';
      case 'medium': return '#f59e0b';
      case 'low': return '#10b981';
      default: return '#6b7280';
    }
  };

  const getPriorityIcon = (priority: string) => {
    switch (priority) {
      case 'high': return '🔴';
      case 'medium': return '🟡';
      case 'low': return '🟢';
      default: return '⚪';
    }
  };

  return (
    <div className="visual-card-small" style={{ border: '2px solid magenta', borderRadius: '8px' }}>
      <div className="visual-card-header">
        <h5 className="text-heading-small">📋 {title}</h5>
      </div>
      <div className="layout-flex-col" style={{ gap: '6px', marginTop: '8px', maxHeight: '220px', overflowY: 'auto' }}>
        {tasksData.map((task) => (
          <div key={task.id} style={{ 
            padding: '8px', 
            borderRadius: '6px', 
            backgroundColor: task.completed ? '#f0f9ff' : '#ffffff',
            border: '1px solid #e5e7eb',
            opacity: task.completed ? 0.7 : 1
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
              <input 
                type="checkbox" 
                checked={task.completed}
                onChange={() => onTaskToggle && onTaskToggle(task.id)}
                style={{ marginTop: '2px', cursor: 'pointer' }}
              />
              <div style={{ flex: 1 }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                  marginBottom: '4px'
                }}>
                  <span className="text-label" style={{ 
                    fontSize: '12px',
                    textDecoration: task.completed ? 'line-through' : 'none'
                  }}>
                    {task.title}
                  </span>
                  <span style={{ fontSize: '10px' }}>{getPriorityIcon(task.priority)}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span className="text-label-muted" style={{ fontSize: '10px' }}>{task.assignee}</span>
                  <span className="text-label-muted" style={{ fontSize: '10px' }}>{task.dueDate}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaskWidget;